import React from 'react';
import ListPane from './listPane.js';
import Toastr from 'toastr';

import AjaxFunctions from '../ajaxFunctions';
import SharedConstants from '../../../../shared/sharedConstants';
import { Typography, Card, CardContent } from '@material-ui/core';

export default class EvidenceTab extends React.Component {
   constructor(props) {
      super(props);
      this.state = {
         items: [],
      };
   }

   componentDidMount() {
      AjaxFunctions.getIncubatorMicroPubs(this.props.idPortfolio).then(items => {
         items = items.filter(item => {
            return item.cardType ===  SharedConstants.CardType.Evidence
               || item.cardType ===  SharedConstants.CardType.Reasoning
         });
         this.setState({ items });
      }).catch(err => {
         Toastr.options.positionClass = 'toast-bottom-full-width';
         Toastr.error(err);
      });
   }

   render() {
      let { items } = this.state;
      let moreLikeThisItems = items.filter(x => x.voteType === SharedConstants.VoteType.UpVote).reverse();
      let mightBeUsefulItems = items.filter(x => x.voteType === SharedConstants.VoteType.None).reverse();
      let holdItems = items.filter(x => x.voteType === SharedConstants.VoteType.DownVote).reverse();
      return (
         <div className={'evidence-tab'}>
            {moreLikeThisItems.length > 0 &&
               <Card style={{marginBottom:'1em'}}>
                  <CardContent>
                     <Typography variant="h5" component="h2" color='primary' className='incubator-card-name' gutterBottom>
                        More Like This
                     </Typography>
                     <ListPane
                        cards={moreLikeThisItems}
                        idPortfolio={this.props.idPortfolio}
                        linkFunction={cardData => this.props.linkFunction(cardData)}
                        tab={this.props.tab}
                     />
                  </CardContent>
               </Card>
            }
            {!this.props.idMania && mightBeUsefulItems.length > 0 &&
               <Card style={{marginBottom:'1em'}}>
                  <CardContent>
                     <Typography variant="h5" component="h2" color='primary' className='incubator-card-name' gutterBottom>
                        Might Be Useful
                     </Typography>
                     <ListPane
                        deckList={this.props.deckList}
                        cards={mightBeUsefulItems}
                        idPortfolio={this.props.idPortfolio}
                        linkFunction={cardData => this.props.linkFunction(cardData)}
                        tab={this.props.tab}
                     />
                  </CardContent>
               </Card>
            }
            {!this.props.idMania && holdItems.length > 0 &&
               <Card>
                  <CardContent>
                     <Typography variant="h5" component="h2" color='primary' className='incubator-card-name' gutterBottom>
                        Hold
                     </Typography>
                     <ListPane
                        deckList={this.props.deckList}
                        cards={holdItems}
                        idPortfolio={this.props.idPortfolio}
                        linkFunction={cardData => this.props.linkFunction(cardData)}
                        tab={this.props.tab}
                     />
                  </CardContent>
               </Card>
            }
         </div>
      );
   }
};
